import { UseQueryOptions } from '@tanstack/react-query';

import useQuery from 'hooks/useQuery';
import { CuredApiPaths, SortDirection } from 'models/enums';

import QueryKeys from './keys';

type UseContactsParams = {
    downloadCSV?: Boolean;
    options?: {
        limit?: string;
        sortColumn?: string;
        sortDirection?: SortDirection;
        segmentId?: number;
        searchTerm?: string;
    };
    reactQueryOptions?: UseQueryOptions<unknown[], Error>;
};

const useContacts = ({ downloadCSV = false, options = {}, reactQueryOptions }: UseContactsParams = {}) => {
    const { limit, sortColumn, sortDirection, segmentId, searchTerm } = options;

    const queryKey = downloadCSV ? QueryKeys.CONTACTS_DOWNLOAD(segmentId) : QueryKeys.CONTACTS(segmentId, searchTerm);

    const params = {
        ...(segmentId && { segmentId }),
        ...(sortColumn && sortDirection && { sort: `${sortColumn}:${sortDirection}` }),
        ...(limit && { limit }),
        ...(searchTerm && { search_term: searchTerm }),
    };

    const headers = {
        ...(downloadCSV && { Accept: 'text/csv' }),
    };

    const axiosOptions = {
        ...(Object.keys(params).length && { params }),
        ...(Object.keys(headers).length && { headers }),
    };

    return useQuery(queryKey, CuredApiPaths.CONTACTS, reactQueryOptions, axiosOptions);
};

export default useContacts;
